import * as React from 'react';

import { Wrapper, IconEdit } from '../../../../Thumbnails/Item/styles';
import ImageWrapper from '../../../../Thumbnails/Item/ImageWrapper';
import ItemInfo from '../../../../Thumbnails/Item/ItemInfo';
import { ThumbnailData, ThumbnailType } from '../../../../Thumbnails/constants';
import Utils from '../../../../../../utils';

interface ItemProps {
	spreadIndex: number;
	thumbnailsData: ThumbnailData[];
	isActive: boolean;
	isEditable: boolean;
	itemsInRow: number | 'AUTO';
	onClick: (index: number, isCtrlPressed?: boolean, isShiftPressed?: boolean) => void;
}

const Item = ({
	spreadIndex,
	thumbnailsData,
	isActive,
	isEditable,
	itemsInRow,
	onClick,
}: ItemProps) => {
	const handleClick = (e: PointerEvent) => {
		onClick(spreadIndex, e.ctrlKey || e.metaKey, e.shiftKey);
	};

	return (
		<Wrapper
			type={ThumbnailType.GRID}
			isActive={isActive}
			itemsInRow={itemsInRow}
			onClick={handleClick}
		>
			<ImageWrapper thumbnailsData={thumbnailsData} />
			<ItemInfo
				spreadIndex={spreadIndex}
				label={thumbnailsData[0].label}
			/>
			{isEditable &&
				<IconEdit>
					{Utils.getSvgIcon('iconset_uprez_edit')}
				</IconEdit>
			}
		</Wrapper>
	);
};

export default Item;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/CombinePanel/SpreadsSelector/Grid/Item/index.tsx